<template>
  <div>
    <navbar></navbar>
    <hr>
    <div class="container is-fluid">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'

export default {
  components: {
    Navbar
  }
}
</script>
